import moment from 'moment';
import range from 'lodash/range';
import { startOfDay, addDays, isSameDay } from 'date-fns';
import dateFnsFormat from 'date-fns/format';

export const nowMoment = moment.utc().startOf('day');
export const nowLocalMoment = moment().startOf('day');

export function getMinDate() {
  return nowMoment.clone().add(-1, 'day');
}

const CALENDAR_FORMATS = {
  sameDay: '[Today]',
  nextDay: '[Tomorrow]',
  nextWeek: 'dddd',
  lastDay: 'MMM D',
  lastWeek: 'MMM D',
  sameElse: 'MMM D',
};

export function formatToCalendarTime(timestamp) {
  return moment(timestamp).calendar(null, CALENDAR_FORMATS);
}

export function formatToDate(timestamp) {
  return new Date(timestamp);
}

export function momentFormat(format) {
  return date => {
    return moment(date).format(format);
  };
}

export function formatHours(timestamp) {
  return moment(timestamp).format('h:mm A');
}

export function humanizeDate(timestamp) {
  return moment(timestamp).format('MMM D, YYYY');
}
export function humanizeLocalDate(timestamp) {
  return moment(timestamp).format('MMM D, YYYY');
}

export function formatDuration(time) {
  const duration = moment.duration(time);
  return moment.utc(duration.as('milliseconds')).format('h:mm A');
}

export function makeDateList(days, startDate = null) {
  const today = startOfDay(new Date());
  const start = startDate ? startOfDay(new Date(startDate)) : today;
  return range(days).reduce((acc, _, i) => {
    const date = addDays(start, i);
    const dayText = dateFnsFormat(date, 'EEE');
    const dateText = dateFnsFormat(date, 'MMM d');
    const isToday = isSameDay(date, today);

    return [
      ...acc,
      {
        timestamp: dateFnsFormat(date, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"),
        dayText,
        dateText: isToday ? 'Today' : dateText,
      },
    ];
  }, []);
}

export const visitExpired = time => moment().isAfter(moment(time), 'date');

function localOffset() {
  const mins = -new Date().getTimezoneOffset();
  const sign = mins >= 0 ? '+' : '-';
  const abs = Math.abs(mins);
  const h = String(Math.floor(abs / 60)).padStart(2, '0');
  const m = String(abs % 60).padStart(2, '0');
  return `${sign}${h}:${m}`;
}

export function getISOString(date) {
  if (date.getHours() === 0 && date.getMinutes() === 0) {
    // this is a fix for Chrome (V8) issue (browsers with another engines work fine)
    // when user selects some date with time 00:00:00
    // Chrome considers it as a previous day
    // in case using regular new Date(date).toISOString() function
    const datePart = dateFnsFormat(date, 'yyyy-MM-dd');
    return `${datePart}T00:00:00.000${localOffset()}`;
  }
  return startOfDay(new Date(date)).toISOString();
}



// WEBPACK FOOTER //
// ./src/utils/appointments/dateFilter.js